'use strict';

/* * taboola factory
 * 1) Inject taboola Scripts and load the first taboola widget on pageLoad
 * 2) Dynamically create taboola container IDs and load taboola widget when url is updated onScroll
 * */

import scriptLoader from "../../fsUtils/ScriptLoader";
import Viewports from "../../fsUtils/Viewports";

angular.module('storyApp').factory('taboola', function() {

    var viewports = new Viewports();

    var taboola = {

        storyUrl: location.href,

        taboolaJS: 'http://cdn.taboola.com/libtrc/foxsports/loader.js',

        firstArticlePlacement: ['Below Article Thumbnails 3x2', 'Mobile Below Article Thumbnails 2x1'],

        taboola: undefined,

        setTaboola: function(v) {
            this.taboola = v;
        },

        isTaboola: function() {
            return this.taboola
        },

        taboolaLoadOnScroll: [],

        /**
         * tabool widget below article
         * @param placement For mobile or non-mobile taboola unit placement
         */
        taboolaOnLoadBelowContent1st: function(placement) {

            window._taboola = window._taboola || [];
            _taboola.push({
                article: 'auto',
                url: taboola.storyUrl
            }, {
                mode: 'thumbnails-b',
                container: 'taboola_below_article_1',
                placement: placement,
                target_type: 'mix'
            }, {
                flush: true
            });
        },

        taboolaOnLoadRightRail1st: function() {

            window._taboola = window._taboola || [];
            _taboola.push({
                article: 'auto',
                url: taboola.storyUrl
            }, {
                mode: 'thumbnails-rr',
                container: 'taboola_right_rail_1',
                placement: 'Right Rail Thumbnails 1x2',
                target_type: 'mix'
            }, {
                flush: true
            });
        },
        /**
         * callback events after taboola script is loaded
         */
        taboolaScriptOnLoad: function() {

            var isMobile = viewports.isMobile;

            //call this.setTaboola(true) to indicate taboola script has loaded
            this.setTaboola(true);
            //load taboola on the right rail for first article
            this.taboolaOnLoadRightRail1st();

            if (isMobile) {
                //load taboola below article content for the first article on mobile
                this.taboolaOnLoadBelowContent1st(this.firstArticlePlacement[1]);
            } else {
                //load taboola below article content for the first article on non-mobile
                this.taboolaOnLoadBelowContent1st(this.firstArticlePlacement[0]);
            }
        },

        createTaboolaBelowConentOnScroll: function(id, elm) {
            var selector = document.querySelector(elm);
            //check if Taboola on the bottom of that story is not rendered
            //since we only want to render bottom Taboola on that story once
            if (!this.taboolaLoadOnScroll[id] && selector !== null) {

                selector.setAttribute('id', id);

                _taboola.push({ article: 'auto', url: location.href }, {
                    mode: 'thumbnails-a',
                    container: id,
                    placement: 'Below Article Thumbnails 3x1 Scroll',
                    target_type: 'mix'
                }, { flush: true });

                this.taboolaLoadOnScroll[id] = true;
            }
        },

        createTaboolaRightRailOnScroll: function(id, elm) {
            var selector = document.querySelector(elm);
            //check if Taboola on the right rail on that story is not rendered
            //since we only want to render right rail Taboola on that story once
            if (!this.taboolaLoadOnScroll[id] && selector !== null) {

                selector.setAttribute('id', id);

                _taboola.push({ article: 'auto', url: location.href }, {
                    mode: 'thumbnails-rr',
                    container: id,
                    placement: 'Right Rail Thumbnails 1x2',
                    target_type: 'mix'
                }, { flush: true });

                this.taboolaLoadOnScroll[id] = true;
            }
        },

        onChange: function(storyInt) {

            //performance.mark('taboola-create-onscroll');

            var isTaboola = this.isTaboola();
            var belowContentE = "#story-" + storyInt + " .taboola_below_content";
            var belowContentId = 'taboola_below_article_' + storyInt;
            var rightrailE = "#story-" + storyInt + " .taboola_right_rail";
            var rightrailId = 'taboola_right_rail_' + storyInt;

            //since the 2nd, 3rd and 4th stories are injected in the dom onScroll,
            //we need to dynamically create taboola id onScrollDown
            //check if the taboola is not created, then create one
            if (isTaboola) {
                this.createTaboolaBelowConentOnScroll(belowContentId, belowContentE);
                //commenting out just in case product wants taboola back 
                //this.createTaboolaRightRailOnScroll(rightrailId, rightrailE);
            }

        },

        init: function() {

            performance.mark('taboola-create-onload');

            /**
             * if taboola script is not loaded, load taboola script. After taboola script is loaded,
             * run callbacks event: this.taboolaScriptOnLoad.
             * Passing true on third param to load the script asynchronously.
             */
            if (!scriptLoader.getLoadedAssets(this.taboolaJS)) {
                scriptLoader.getScript(this.taboolaJS, this.taboolaScriptOnLoad.bind(this), true);
                //call setLoadedAssets to indicate that Taboola JS has been loaded
                scriptLoader.setLoadedAssets(this.taboolaJS, true);
            }

        }

    };

    taboola.init();

    return taboola;

});


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/taboola.js